import { render, staticRenderFns } from "./CorrectionModal.vue?vue&type=template&id=43611fb2"
import script from "./CorrectionModal.vue?vue&type=script&lang=js"
export * from "./CorrectionModal.vue?vue&type=script&lang=js"
import style0 from "./CorrectionModal.vue?vue&type=style&index=0&id=43611fb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports